module.exports = __webpack_public_path__ + "static/media/0008.5a213854.jpg";